import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export function DeleteOutlineIcon(props: SvgIconProps): React.ReactElement {
  return (
    <SvgIcon width="20" height="20" style={{ cursor: 'pointer' }} viewBox="0 0 24 24">
      <path
        fill="#0074CA"
        d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z"
      ></path>
    </SvgIcon>
  );
}
